import React, { Component } from "react";
import { ErrorBox } from "../components/ErrorBox.tsx";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import { NextButton } from "../components/NextButton.tsx";
import { PreviousButton } from "../components/PreviousButton.tsx";
import { LenderRow } from "../components/LenderRow";

interface IProps {
  gtmEvent(): void;
  prevStep(): void;
  nextStep(): void;
  dob: Date;
  applicant: number;
  updateLead(props: any): void;
}

interface IState {
  hasError: boolean;
  errors?: string[];
  dob: Date;
}

export class DOB extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      hasError: false,
      dob: this.props.dob,
    };
  }

  componentDidMount(): void {
    this.props.gtmEvent();
  }

  nextStep() {
    var dob = this.state.dob;
    if (!dob || dob < new Date(1950, 0, 1) || dob > new Date(2010, 0, 1)) {
      var errors: string[] = [];
      errors.push(
        "A valid date of birth is required. Please use dd-mm-yyyy format"
      );
      this.setState({ errors: errors, hasError: true });
      return;
    }
    this.props.nextStep();
  }

  getDate(e) {
    if (!e) {
      return null;
    }
    return new Date(e);
  }

  render() {
    return (
      <header className="App-header">
        <div className="wrapper">
          <h2>
            {this.props.applicant === 1 ? (
              <>
                And my <span className="doddltext">date of birth</span> is
              </>
            ) : (
              <>
                And my partner's{" "}
                <span className="doddltext">date of birth</span> is
              </>
            )}
          </h2>
          <div className="row">
            <div className="column2">
              <DatePicker
                id="dob1"
                minDate={new Date(1950, 0, 1)}
                maxDate={new Date(2010, 0, 1)}
                value={this.state.dob ?? new Date(1990, 0, 1)}
                className={this.state.hasError && !this.state.dob ? "e" : ""}
                clearIcon={null}
                onChange={(e: any) => {
                  var d = this.getDate(e);
                  this.setState({ dob: d });

                  if (this.props.applicant === 1) {
                    this.props.updateLead({ dateOfBirth1: d });
                  } else {
                    this.props.updateLead({ dateOfBirth2: d });
                  }
                }}
              />
            </div>
          </div>
          {this.state.hasError && <ErrorBox errors={this.state.errors!} />}
          <div className="row">
            <div className="button-group">
              <PreviousButton onClick={() => this.props.prevStep()} />
              <NextButton onClick={() => this.nextStep()} />
            </div>
          </div>
          <div className="row mt-2">
            <LenderRow />
          </div>
        </div>
      </header>
    );
  }
}
